<div class="page-holder">
  <div class="research-header">
    <span>Research</span>
  </div>
  <div class="separator">
    <div class="separator-line"></div>
  </div>
  <div class="toolbar filters-container" *ngIf="dataSet && !hasError">
    <div *ngIf="selectedRows.length > 1" class="selection-bar">
      <h3>{{ selectedRows.length }} items selected</h3>
      <va-icon
        size="small"
        name="download"
        nz-tooltip
        nzTooltipTitle="Download All"
        class="fa-lg icon-download"
        (click)="downloadAll($event)"
      ></va-icon>
      <span class="pull-right cancel-btn" (click)="onClickCancel()"
        >Cancel</span
      >
    </div>
    <div *ngIf="selectedRows.length <= 1" class="filters-container">
      <div class="filter">
        <span>
          <app-date-filter></app-date-filter>
        </span>
      </div>
      <div class="filter">
        <app-multi-select-dropdown
          [data]="analystData"
          (callback)="analystChange($event)"
          *ngIf="analystDataSet"
        >
        </app-multi-select-dropdown>
      </div>
      <div class="filter">
        <app-multi-select-dropdown
          [data]="brokerData"
          (callback)="brokerChange($event)"
          *ngIf="brokerDataSet"
        >
        </app-multi-select-dropdown>
      </div>
      <div class="filter">
        <span class="primary-ticker-text">Primary Ticker On</span>
        <span
          nz-tooltip
          nzTooltipTitle="Only show research where {{
            ticker
          }} is primarily identified"
        >
        <nz-switch
          [(ngModel)]="isPrimayTicker"
          (click)="primaryTickerSwitchChange()"
        ></nz-switch>
        </span>
      </div>
      <div class="filter">
        <div class="reset" (click)="resetAll()">
          <va-icon size="small" name="redo" class="fa-sm reset-icon"></va-icon>
          <label class="reset-lbl">Reset</label>
        </div>
      </div>
      <!-- separator-line -->
      <nz-divider nzType="vertical"></nz-divider>
      <div class="filter">
        <div class="result-count">
          <span>{{ totalResultCount }} Results</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loadingDocuments" class="loader-container">
    <ng-template #indicatorTemplate>
      <va-icon
        [isFontAwesome]="true"
        [name]="faSpinner"
        [spin]="true"
        [styles]="{
          'font-size': '34px',
          top: '50%',
          left: '50%',
          position: 'absolute'
        }"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </div>
  <div class="ant-grid-container" *ngIf="dataSet && !hasError">
    <app-ant-grid-custom
      (paginationChange)="getNextPageData($event[0], $event[1])"
      (selectedRows)="getSelectedRows($event[0])"
      (sortChange)="onSortChange($event[0])"
      [dataToUse]="dataToUse"
      [resetSelection]="resetSelection"
    >
    </app-ant-grid-custom>
  </div>
  <div class="error-container" *ngIf="hasError">
    <div class="error-msg">
      <va-icon name="info-circle" class="info-icon"></va-icon>
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</div>
